export default __webpack_public_path__ + "static/media/black_queen.98a579f2.png";